module.exports = __webpack_public_path__ + "img/4.9f3b45e0.png";